import React, { useState } from 'react';
import { useEffect } from 'react';
import ProfileCard from '../components/common/ProfileCard';
import PocketBase from "pocketbase";
import PromoCard from '../components/common/PromoCard';

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);


const TecherProfile = () => {
const [teachers, setTeachers] = useState([]);
const [promo, setPromos] = useState([]);
const [, setIsLoading] = useState(true);
const [, setError] = useState('');

useEffect(() => {
  const fetchClasses = async () => {
    try {
      setIsLoading(true);
      setError('');
      const response = await pb.collection('Teachers').getFullList({
        sort:'created'
      })

      const res = await pb.collection('Class_Promo').getList(1,15);

      if (Array.isArray(res.items)) {
        setPromos(res.items);
      }
      
      
      if (Array.isArray(response)) {
        setTeachers(response);
      } else {
        throw new Error('Unexpected data format from API');
      }
    } catch (error) {
      console.error('Error fetching notes:', error);
      setError('Failed to load notes. Please try again later.');
      setTeachers([]);
    } finally {
      setIsLoading(false);
    }
  }
  fetchClasses();
}, []);



    return (
        <div className='flex  flex-col justify-center '>
            {teachers.map((teacher) => (
                <ProfileCard key={teacher.id} teacher={teacher} />
            ))}
            <div className='heading text-center py-2'>
                <h1 className='text-3xl font-semibold text-black'>Promotion</h1>
            </div>
            <div className='m-4 flex sm:flex-col'>
              {promo.map((promo) => (
                <PromoCard 
                  key={promo.id}
                  imageUrl={`${process.env.REACT_APP_POCKETBASE_URL}/api/files/${promo.collectionId}/${promo.id}/${promo.image}`}
                  description={promo.description}
                  whatsappNumber={promo.whatsappNumber}
                  message={promo.message}
                />
              ))}
            </div>
        </div>
    );
};


export default TecherProfile;